
/**
 * Module dependencies.
 */

import { ConfirmationModal, ConfirmationModalProps } from './confirmation-modal';
import { color } from 'react-components/styles';
import { useTranslate } from '../../i18n';
import styled from 'styled-components';
import warningIconDesktop from '../assets/svg/72/warning.svg';
import warningIconMobile from '../assets/svg/40/warning.svg';

/**
 * `Props` type.
 */

type Props = Pick<ConfirmationModalProps, 'closeOnPressBackdrop' | 'disabled' | 'isLoading' | 'isVisible' | 'onConfirm' | 'onRequestClose'> & {
  description?: string;
  entityName?: string;
};

/**
 * `StyledConfirmationModal` styled component.
 */

const StyledConfirmationModal = styled(ConfirmationModal)`
  color: ${color('warning500')};
`;

/**
 * Export `DeleteModal` component.
 */

export function DeleteModal(props: Props): JSX.Element {
  const { description, entityName, onRequestClose, ...rest } = props;
  const { translate } = useTranslate();

  return (
    <StyledConfirmationModal
      {...rest}
      cancelButtonLabel={translate('modal.delete.cancelButtonLabel')}
      confirmButtonLabel={translate('modal.delete.confirmButtonLabel')}
      description={description ?? translate('modal.delete.description', {
        ...entityName ? { entityName } : {}
      })}
      desktopIcon={warningIconDesktop}
      iconColor={color('warning')}
      mobileIcon={warningIconMobile}
      onCancel={onRequestClose}
      onRequestClose={onRequestClose}
      title={translate('modal.delete.title')}
    />
  );
}
